
import { createApi } from "@reduxjs/toolkit/query/react";
import { defautBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";
import { transformRequest } from "../../../utils/API/requestMiddleware";


const CPDApi = createApi({
    baseQuery: defautBaseQuery,
    reducerPath: 'CPDApi',
    endpoints: (builder) => ({
        acceptCpdSubmission: builder.mutation({
            query: (details) => ({
                url: '/CPD/ApproveCPDActivity',
                method: 'POST',
                body: transformRequest(details,"update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        rejectCpdSubmission: builder.mutation({
            query: (details) => ({
                url: '/CPD/RejectCPDSubmissionApplication',
                method: 'POST',
                body: transformRequest(details,"update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        UploadCpdBatch: builder.mutation({
            query: (details) => ({
                url: '/CPD/UploadCpdBatch',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GetUploadedCPDList: builder.mutation({
            query: (details) => ({
                url: '/CPD/GetUploadedCPDList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GetCPDRenewalCycleList: builder.mutation({
            query: (details) => ({
                url: '/CPD/GetCPDRenewalCycleList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GetCommitteBatchApprovalCPDEventListByBatchNo: builder.mutation({
            query: (details) => ({
                url: '/CPDEvent/GetCommitteBatchApprovalCPDEventListByBatchNo',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateCpdStatusToInvalid: builder.mutation({
            query: (details) => ({
                url: '/CPD/UpdateCpdStatusToInvalid',
                method: 'POST',
                body: transformRequest(details,"update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getGreenMarkProjectList: builder.mutation({
            query: (details) => ({
                url: '/CPD/GetGreenMarkProjectList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        downloadSheetForGreenMarkProjectList: builder.mutation({
            query: (details) => ({
                url: '/CPD/DownloadSheetForGreenMarkProjectList',
                method: 'POST',
                body: transformRequest(details),
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        downloadSheetForCPDRenewalCycle: builder.mutation({
            query: (details) => ({
                url: '/CPD/DownloadSheetForCPDRenewalCycle',
                method: 'POST',
                body: transformRequest(details),
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const {
    useAcceptCpdSubmissionMutation,
    useRejectCpdSubmissionMutation,
    useUploadCpdBatchMutation,
    useGetUploadedCPDListMutation,
    useGetCPDRenewalCycleListMutation,
    useGetCommitteBatchApprovalCPDEventListByBatchNoMutation,
    useUpdateCpdStatusToInvalidMutation,
    useGetGreenMarkProjectListMutation,
    useDownloadSheetForGreenMarkProjectListMutation,
    useDownloadSheetForCPDRenewalCycleMutation
} = CPDApi;

export default CPDApi;